import { axios } from "@/config/axios";

// enums
import { ApiResource } from "@/enums/ApiResource";

// interfaces
import type { UiFeatures } from "@/interfaces/UiFeatures";

export const uiFeaturesApi = () => ({
  getUiFeatures: ({ companyId }: { companyId: string }): Promise<UiFeatures> =>
    axios.get(`${ApiResource.PANEL_API}/${companyId}/ui-features`),
});
